var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoHydraulikoel48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.3,20.7h9.3c0.8,0,1.4-0.5,1.4-1.1s-0.6-1.1-1.4-1.1h-9.3c-0.8,0-1.4,0.5-1.4,1.1S18.5,20.7,19.3,20.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9,
    y: 12,
    width: 2.1,
    height: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.8,15.2 30.8,34.8 17.2,34.8 17.2,15.2 16,15.2 16,36 32,36 32,15.2  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2,29.9c0,1.5,1.7,2.5,2.6,2.5H24c0.8,0,2.6-1,2.6-2.5s-2.7-7.5-2.7-7.5h0C23.9,22.4,21.2,28.4,21.2,29.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoHydraulikoel48);
export default __webpack_public_path__ + "static/media/ic_bevo_hydraulikoel_48.f86d5558daa48cf1b47e9fc78247cac5.svg";
export { ForwardRef as ReactComponent };